import { useEffect } from 'react';

const LINK_DIST = 110;
const MOUSE_DIST = 110;

const createParticles = (w, h) =>
  Array.from({ length: Math.min(70, Math.floor(w / 18)) }, () => ({
    x: Math.random() * w,
    y: Math.random() * h,
    vx: (Math.random() - 0.5) * 0.35,
    vy: (Math.random() - 0.5) * 0.35,
    r: Math.random() * 1.6 + 0.6
  }));

const stepParticle = (p, w, h, mouse) => {
  p.x += p.vx;
  p.y += p.vy;
  if (p.x < 0 || p.x > w) p.vx *= -1;
  if (p.y < 0 || p.y > h) p.vy *= -1;
  const dx = p.x - mouse.x;
  const dy = p.y - mouse.y;
  const md = Math.hypot(dx, dy);
  if (md < MOUSE_DIST) {
    p.x += (dx / md) * 0.6;
    p.y += (dy / md) * 0.6;
  }
};

const drawDot = (ctx, p) => {
  ctx.beginPath();
  ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(0, 136, 204, 0.55)';
  ctx.fill();
};

const drawLinks = (ctx, particles) => {
  ctx.lineWidth = 0.7;
  for (let i = 0; i < particles.length; i++) {
    for (let j = i + 1; j < particles.length; j++) {
      const a = particles[i];
      const b = particles[j];
      const d = Math.hypot(a.x - b.x, a.y - b.y);
      if (d >= LINK_DIST) continue;
      ctx.beginPath();
      ctx.moveTo(a.x, a.y);
      ctx.lineTo(b.x, b.y);
      ctx.strokeStyle = `rgba(45, 59, 82, ${1 - d / LINK_DIST})`;
      ctx.stroke();
    }
  }
};

export function useParticleField(canvasRef) {
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const mouse = { x: -9999, y: -9999 };
    let raf;
    let w = 0;
    let h = 0;

    const resize = () => {
      w = canvas.width = canvas.offsetWidth;
      h = canvas.height = canvas.offsetHeight;
    };
    const onMouse = (e) => {
      const rect = canvas.getBoundingClientRect();
      mouse.x = e.clientX - rect.left;
      mouse.y = e.clientY - rect.top;
    };

    resize();
    const particles = createParticles(w, h);

    const frame = () => {
      ctx.clearRect(0, 0, w, h);
      particles.forEach((p) => {
        stepParticle(p, w, h, mouse);
        drawDot(ctx, p);
      });
      drawLinks(ctx, particles);
      raf = requestAnimationFrame(frame);
    };

    window.addEventListener('resize', resize);
    window.addEventListener('mousemove', onMouse);
    frame();

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('resize', resize);
      window.removeEventListener('mousemove', onMouse);
    };
  }, [canvasRef]);
}
